var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-status text-status",class:_vm.getBadgeStatusClass(
      _vm.stage,
      _vm.status,
      _vm.createdAt,
      _vm.updateStatus,
      _vm.pickupDate,
      _vm.timezone
    )},[_vm._v("\n  "+_vm._s(_vm.getBadgeStatusLabel(_vm.stage, _vm.status, _vm.updateStatus))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }